import { createSlice } from '@reduxjs/toolkit';
import { handleGetQuickbook, handleGetQuickbookCustomers } from './quickbookThunk';
import { IQuickbook, IQuickbookCustomer } from '~/utils/interface/quickbook';

export interface QuickbookState {
  quickbook?: IQuickbook;
  quickbookCustomers?: Array<IQuickbookCustomer>;
}

const initialState: QuickbookState = {
  quickbook: undefined,
  quickbookCustomers: [],
};

const quickbookSlice = createSlice({
  name: 'quickbook',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(handleGetQuickbook.fulfilled, (state, action) => {
      state.quickbook = { ...action.payload };
    });
    builder
      .addCase(handleGetQuickbookCustomers.pending, (_state, _action) => {})

      .addCase(handleGetQuickbookCustomers.fulfilled, (state, action) => {
        state.quickbookCustomers = [...action.payload.responses];
      })

      .addCase(handleGetQuickbookCustomers.rejected, (_state, _action) => {});
  },
});

export const quickbookActions = quickbookSlice.actions;

const quickbookReducer = quickbookSlice.reducer;
export default quickbookReducer;
